import supabase from "artifact/supabase";
import connected from "standard/connected";
import define from "standard/define";
import on from "standard/on";
import paint from "standard/paint";
import repaint from "standard/repaint";
import trait from "standard/trait";
import willPaint from "standard/willPaint";
import icon from "./icon";
import style from "./style";

@define("m-classlist")
class Classlist extends HTMLElement {
  #classes = [];

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <table class="${style.classlist__table}">
        <thead class="${style.classlist__thead}">
          <tr class="${style.classlist__tr}">
            <th>Turma</th>
            <th>Ativar</th>
            <th>Desativar</th>
            <th>Ativo</th>
          </tr>
        </thead>
        <tbody class="${style.classlist__tbody}">
          ${this.#classes
            .map(
              (classes) => `
            <tr class="${style.classlist__tr}">
              <td>${classes.name}</td>
              <td>
                <button class="${style.classlist__on}" data-class="${classes.id}" style="opacity: ${classes.classroom[0]?.live ? "0.3" : "1"}" >
                  ${icon.on()}
                </button>
              </td>
              <td>
                <button class="${style.classlist__off}" data-class="${classes.id}" style="opacity: ${classes.classroom[0]?.live ? "1" : "0.3"}">
                  ${icon.off()}
                </button>
              </td>
              <td>
                ${
                  classes.classroom.length && classes.classroom[0].live
                    ? `
                    <a class="${style.classlist__link}" data-class="${classes.id}" href="/app/${this.dataset.user}/${this.dataset.school}/live/${classes.classroom[0]?.daily_id}" target='_blank'>
                      ${icon.link()}
                    </a>
                  `
                    : ""
                }
              </td>
            </tr>
          `,
            )
            .join("")}
        </tbody>
      </table>

    `;
  }

  @willPaint
  async [trait.fetch]() {
    const { data: classes } = await supabase
      .from("class")
      .select("*, level_of_education!inner(*, grade!inner(*)), classroom(*)")
      .eq("level_of_education.grade.school_id", this.dataset.school)
      .eq("level_of_education.id", "171ed5cf-f6c9-4128-adcc-b8498ad364ca")
      .order("name", { ascending: true });

    this.#classes = classes;
    return this;
  }

  @on.click(`button.${style.classlist__on}`)
  @repaint
  async [trait.on](event) {
    const confirmed = window.confirm(
      "Tem certeza que gostaria de ativar esta sala?",
    );

    if (confirmed) {
      await supabase
        .from("classroom")
        .update({ live: true })
        .eq("class_id", event.target.dataset.class);
    }

    return this;
  }

  @on.click(`button.${style.classlist__off}`)
  @repaint
  async [trait.off](event) {
    const confirmed = window.confirm(
      "Tem certeza que gostaria de desativar esta sala?",
    );

    if (confirmed) {
      await supabase
        .from("classroom")
        .update({ live: false })
        .eq("class_id", event.target.dataset.class);
    }

    return this;
  }
}

export default Classlist;
